function extractPathname(path: string) {
  return path.includes('manager/') ? path.split('manager/')[1] || '' : path;
}

export function useRememberQueryParams(pathname: string) {
  // Extract the pathname from the URL and get the query params from localStorage
  const localParams = localStorage.getItem(`search_${extractPathname(pathname)}`);
  return localParams ? new URLSearchParams(JSON.parse(localParams)) : undefined;
}

export default useRememberQueryParams;
